<template>
	<div class="form-group">
		<label class="element-label" :for="module+'-status'" data-msg="Select Status">Status</label>
		<multiselect v-model="status" :options="statusOptions" :multiple="false" :searchable="false" :allowEmpty="false" :showLabels="false" :maxHeight="200" :id="module+'-status'" :name="module+'Status'" :placeholder="'Select '+toTitleCase(module)+' Status'">
		</multiselect>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { EventBus } from '@/event-bus.js'

export default {
	name: 'Status',
	props: {
		module: String,
		data: "",
		default: ""
	},
	components: {
		Multiselect
	},
	data() {
		return {
			status: "",
			statusOptions: [
			'New',
			'Discussing',
			'Negotiating',
			'Followup',
			'Lost'
			]
		}
	},
	computed: {

	},
	mounted() {
		EventBus.$on('reset-form', () => {
			this.resetData();
		});
		// Set Default Value
		this.default != "" ?	this.status = this.default :	this.status = "";
	},
	methods: {
		resetData: function() {
			this.status = "";
		}
	},
	watch: {
		status: function() {
			this.$emit('update:data', this.status)
		}
	}
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>